import { render, staticRenderFns } from "./ShengCaipanManage.vue?vue&type=template&id=2de4ab14&"
import script from "./ShengCaipanManage.vue?vue&type=script&lang=js&"
export * from "./ShengCaipanManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports